import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { TieredAccountCell } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountCell/TieredAccountCell';
import { ColumnOptions } from 'src/components/EnterpriseSetupTable/EnterpriseSetupTable';

export interface TieredAccountHeaderTextProps {
  headerText: string;
  width: ColumnOptions;
}

export const TieredAccountHeaderText: React.FC<TieredAccountHeaderTextProps> =
  ({ width, headerText }) => {
    return (
      <TieredAccountCell width={width}>
        <Copy variant="body" color="secondaryText">
          {headerText}
        </Copy>
      </TieredAccountCell>
    );
  };
